import React, {
  Fragment,
  FunctionComponent,
  useEffect,
  useRef,
  useState,
} from "react";
import "./uploadDocument.scss";
import InfoIcon from '@material-ui/icons/Info';

import AxisButton from "../../components/button/button";
import Text from "../../components/typography/typgraphy";
import {
  VINTAGE_PAGE_HEADING,
  VINTAGE_PAGE_DESCRIPTION,
  UPLOAD_BANK_STATEMENT,
  PASSWORD_INPUT_PLACEHOLDER,
} from "../../constants/messages";
import Loader from "../../components/loader/loader";
import {
  IErrorResponseType,
  IInstitutionListResponse,
  ISuccessResponseType,
} from "../../constants/commonTypes";
import AsyncAutocomplete from "../../components/autocomplete/autocomplete";
import { ClearIcon, RightTickFilled } from "../../assets/svgs/svg";
import {
  getTransactionIdFromURL,
  resetInput,
  trimFileName,
} from "../../constants/utils";
import Checkbox from "../../components/checkbox/checkbox";
import TextInput from "../../components/textInput/textInput";
import { useDebounce } from "../../constants/customHooks";
import PageHeader from "../../components/pageHeader/pageHeader";
import { APP_URLS, ARGO_SUCCESS, ERROR_CODES } from "../../constants/constants";
import { useHistory } from "react-router";
import Card from "../../components/cards/card";
import { UploadDetailsState } from "../../core/reducers/uploadDocumentReducer";
import { TransactionState } from '../../core/reducers/transactionDetailsReducer';

import {pushDataLayer, UPLOAD_STATEMENT_PAGELOAD_VPV, UPLOAD_STATEMENT_PAGELOAD_PARAM, DO_LATER_GA, CONTINUE_GA, CONCENT_CHECKBOX_GA, UPLOAD_GA, UPLOAD_NO_GA, UPLOAD_YES_GA, UPLOAD_LATER_PAGELOAD_VPV, UPLOAD_LATER_PAGELOAD_PARAM } from '../../constants/gaConstants';
import { AuthState } from "../../core/reducers/authReducer";
import NotAllowedCharsModal from "../notAllowedChars/notAllowedCharsModal";

interface IUploadDocumentProps {
  error: IErrorResponseType | null;
  institutionList: Array<IInstitutionListResponse>;
  uploadDocumentResponse: Array<ISuccessResponseType>;
  isLoading: boolean;
  transactionId: string;
  isAuthenticated: boolean;
  perfiosTxnId: string;
  inAppBackPressed: boolean;
  uploadDocumentCompleted: boolean;
  resumeJourneyEligibility: boolean;
  uploadDetailsResponse: UploadDetailsState;
  fetchInstitutionList: (q: string) => void;
  uploadDocuments: (q: string, d: FormData) => void;
  initiateUploadDocuments: (q: object) => void;
  uploadDetails: (q: object) => void;
  resetTransactionSummary: () => void;
  uploadDocumentReset: () => void;
  transactionDetails: TransactionState;
  partnerData: AuthState;
}

const UploadDocument: FunctionComponent<IUploadDocumentProps> = (props) => {
  const {
    isLoading,
    institutionList,
    error,
    isAuthenticated,
    perfiosTxnId,
    uploadDocumentResponse,
    resumeJourneyEligibility,
    inAppBackPressed,
    uploadDocumentCompleted,
    uploadDetailsResponse,
    fetchInstitutionList,
    uploadDocuments,
    uploadDetails,
    initiateUploadDocuments,
    resetTransactionSummary,
    uploadDocumentReset,
    transactionDetails,
    partnerData
  } = props;
  const [institutionOptions, setInstitutionOptions] = useState([] as IInstitutionListResponse[])
  const [disableProceed, setDisableProceed] = useState(true)
  const [disableUpload, setDisableUpload] = useState(false)
  const [fileSizeErrpr, setFileSizeError] = useState(false)
  const [fileTypeErrpr, setFileTypeError] = useState(false)
  const [uploadFailure, setUploadFailure] = useState(false)
  const [isBankSelected, setIsBankSelected] = useState(true)
  const [isFieldsDisabled, setIsFieldDisabled] = useState(false)
  const [isUploadDetailsAPICalled, setIsUploadDetailsAPICalled] = useState(false)
  const [bankQueryText, setBankQueryText] = useState('')
  const [isChecked, setIsChecked] = useState(false)
  const [isCheckedConsent, setisCheckedConsent] = useState(false)
  const [documentInputKey, setDocumentInputKey] = useState('')
  const [password, setPassword] = useState('')
  const [proceedClicked, setProceedClicked] = useState(false)
  const inputRef = useRef<HTMLInputElement>(null)
  const [continueLater, setContinueLater] = useState(true);
  const debouncedSearchTerm = useDebounce(bankQueryText, 1000);
  const history = useHistory();
  const txnId = getTransactionIdFromURL();

  const [documents, setDocuments] = useState([] as File[])
  const [errorMessage, setErrorMessage] = useState('')
  const [openModal, setOpenModal] = useState(false);

  const blockInvalidChar = (e) => ["#", "!", "%", "$", "^", "`", "~", "(", ")", "*", "<", ">", "'", '"'].includes(e.key) && e.preventDefault();


  // GA on page load
  useEffect(() => {
    if(continueLater){
      pushDataLayer(UPLOAD_STATEMENT_PAGELOAD_VPV(partnerData.customerId, transactionDetails.submitRequest.finalRemittanceAmt, txnId, transactionDetails.purposeCode, transactionDetails.submitRequest.funds.source))
      pushDataLayer(UPLOAD_STATEMENT_PAGELOAD_PARAM(partnerData.customerId, transactionDetails.submitRequest.finalRemittanceAmt, txnId, transactionDetails.purposeCode, transactionDetails.submitRequest.funds.source))
    }
    else{
      pushDataLayer(UPLOAD_LATER_PAGELOAD_VPV(partnerData.customerId, transactionDetails.submitRequest.finalRemittanceAmt, txnId, transactionDetails.purposeCode, transactionDetails.submitRequest.funds.source))
      pushDataLayer(UPLOAD_LATER_PAGELOAD_PARAM(partnerData.customerId, transactionDetails.submitRequest.finalRemittanceAmt, txnId, transactionDetails.purposeCode, transactionDetails.submitRequest.funds.source))
    }
  }, [continueLater])

  useEffect(() => {
    if (uploadDetailsResponse.fileList.length > 0) {
      setIsFieldDisabled(true)
      if (uploadDetailsResponse.passwordFlag) {
        setIsChecked(true)
        setPassword("********")
      }
      resetTransactionSummary()
    }
  }, [uploadDetailsResponse, resetTransactionSummary])

  const handleProceed = async () => {
    pushDataLayer(CONTINUE_GA(partnerData.customerId, transactionDetails.submitRequest.finalRemittanceAmt, txnId, transactionDetails.purposeCode, transactionDetails.submitRequest.funds.source))

    if (isFieldsDisabled) {
      history.push(`${APP_URLS.TRANSACTION_SUMMARY.replace(":txnId", txnId)}`);
    } else {
      let selectedOption = institutionOptions.find(element => element.institutionName === bankQueryText)

      let req = {
        institutionId: selectedOption?.institutionId,
        uploadConsentVersion: transactionDetails.uploadFileVersion
      }
      initiateUploadDocuments(req)
      setProceedClicked(true)
    }
  }

  const handleSelectBank = (value: any) => {
    if (value !== null) {
      setIsBankSelected(false)
    } else {
      setIsBankSelected(true)
    }
  }

  const resetFields = () => {
    setDocuments([])
    setIsChecked(false)
    setPassword("")
    setProceedClicked(false)
  }
  useEffect(() => {
    if (error) {
      let exceptionError = Object.values(ERROR_CODES.EXCEPTIONS).includes(error.code);
      if (!exceptionError) {
        history.push({
          pathname: `${APP_URLS.ERROR.replace(":txnId", txnId)}`,
          state: { errorCode: error.code },
        });
      } else {
        if (error.code) {
        }
        switch (error.code) {
          case ERROR_CODES.EXCEPTIONS.FILE_SIZE_EXCEPTION:
            setFileSizeError(true)
            resetFields()
            break;
          case ERROR_CODES.EXCEPTIONS.FILE_FORMAT_EXCEPTION:
            setFileTypeError(true)
            resetFields()
            break;
          case ERROR_CODES.EXCEPTIONS.PERFIOS_STATEMENT_UPLOAD_FAILURE:
            setUploadFailure(true)
            resetFields()
            break;
          default:
            break;
        }
      }
    }
  }, [error, history, txnId])

  useEffect(() => {
    if (inAppBackPressed && uploadDocumentCompleted && !isUploadDetailsAPICalled) {
      setIsUploadDetailsAPICalled(true)
      let req = {
        pefiosTxnId: perfiosTxnId
      }
      uploadDetails(req)
    }
  }, [inAppBackPressed, uploadDocumentCompleted, perfiosTxnId, uploadDetails, isUploadDetailsAPICalled])

  useEffect(() => {

    setErrorMessage("")
    
    if ((inAppBackPressed && uploadDocumentCompleted) || isUploadDetailsAPICalled) return;
    if (isFieldsDisabled || uploadDetailsResponse.fileList.length > 0) return;
    let uploadSuccess = uploadDocumentResponse.every((val) => {
      return val.code === ARGO_SUCCESS;
    });
    if (!uploadSuccess) {

      /**
     * ARGO-506: show the error comming from backend in case of upload failure for single file error.
     */

     uploadFailureErrorMessage()

      setUploadFailure(true)
      resetFields()
      uploadDocumentReset()
      return
    }
    if (uploadDocumentResponse.length > 0 && uploadSuccess) {
      history.push(`${APP_URLS.TRANSACTION_SUMMARY.replace(":txnId", txnId)}`);
    }
  }, [uploadDocumentResponse, uploadDocumentReset, isFieldsDisabled, isUploadDetailsAPICalled, uploadDocumentCompleted, uploadDetailsResponse, inAppBackPressed, history, txnId])


  useEffect(() => {
    /**
     * ARGO-501: Added document check to stop incomplete duplicate upload request
     */
    if (!proceedClicked || inAppBackPressed || uploadDocumentCompleted || (documents.length <= 0)) return;
    if (perfiosTxnId) {
      let documentFormData: FormData = new FormData();
      for (var i = 0; i < documents.length; i++) {
        documentFormData.append("statements", documents[i]);
      }

      let perfTxnId = perfiosTxnId;
      if (isChecked) {
        perfTxnId += "&password=" + password;
      }

      uploadDocuments(perfTxnId, documentFormData);
    }
  }, [perfiosTxnId, documents, isChecked, inAppBackPressed, uploadDocumentCompleted, uploadDocuments, password])

  useEffect(() => {
    function getDetails() {
      fetchInstitutionList(debouncedSearchTerm);
    }
    if (isAuthenticated && debouncedSearchTerm) {
      getDetails();
    }
  }, [isAuthenticated, debouncedSearchTerm, fetchInstitutionList]);

  useEffect(() => {
    if (!debouncedSearchTerm) {
      setInstitutionOptions([]);
      return;
    }
    setInstitutionOptions(institutionList);
  }, [debouncedSearchTerm, institutionList]);

  useEffect(() => {
    if (isFieldsDisabled && isCheckedConsent) {
      setDisableProceed(false)
      return;
    }
    if (bankQueryText === "" || documents.length === 0) {
      setDisableProceed(true);
    } else if (isChecked && password.length === 0) {
      setDisableProceed(true);
    } else if (fileSizeErrpr || fileTypeErrpr) {
      setDisableProceed(true);
    } else if(!isCheckedConsent){
        setDisableProceed(true);
      }
     else {
      setDisableProceed(false);
    }
  }, [setDisableProceed, isFieldsDisabled, documents, fileTypeErrpr, fileSizeErrpr, isChecked, password, bankQueryText, isCheckedConsent])


  useEffect(() => {
    if (documents.length > 0) {
      const isFileTypeError = documents.some(
        (doc) => doc.type !== "application/pdf"
      );
      setFileTypeError(isFileTypeError);
      if (isFileTypeError) {
        setDisableUpload(true);
      } else {
        const isFileSizeError = documents.some(
          (doc) => Math.floor(doc.size / 1048576) > 2
        );
        setFileSizeError(isFileSizeError);
        if (isFileSizeError) {
          setDisableUpload(true);
        } else {
          setDisableUpload(false);
        }
      }
    }
  }, [documents]);

  useEffect(() => {
    if (documents.length === 4) {
      setDisableUpload(true);
    } else {
      setDisableUpload(false);
    }
  }, [setDisableUpload, documents]);

  const uploadFailureErrorMessage = () => {
    let flagMulError = false;
    uploadDocumentResponse.map((e)=>{
      
      if(e.code==8502 && !flagMulError){

        setErrorMessage(e.error_message)
        flagMulError = true
      }
      else if(e.code==8502 && flagMulError){
        setErrorMessage("Something went wrong. Please check if all the criteria mentioned for file upload are accurate.")
      }
      
    })
  }

  const resetError = () => {
    setUploadFailure(false);
    setFileSizeError(false);
    setFileTypeError(false);
  }

  const handleOnDocumentSelected = () => {
    pushDataLayer(UPLOAD_GA(partnerData.customerId, transactionDetails.submitRequest.finalRemittanceAmt, txnId, transactionDetails.purposeCode, transactionDetails.submitRequest.funds.source))

    if (inputRef && inputRef.current) {
      let currentSelectedFile = inputRef.current.files;
      if (currentSelectedFile && currentSelectedFile?.length > 0) {
        let listOfFIles = documents;
        listOfFIles.push(currentSelectedFile[0]);
        setDocuments([...listOfFIles]);
        setDocumentInputKey(resetInput());
        resetError();
      }
    }
  };

  const removeUploadedDocument = (index: number) => {
    let documnetsArr = documents;
    documnetsArr.splice(index, 1);
    documnetsArr.length < 1 ? setIsChecked(false) : setIsChecked(isChecked);
    setDocuments([...documnetsArr]);
  };

  const handleCheckboxClick = () => {
    setIsChecked(!isChecked);
  };

  const handleConsentCheckboxClick = () => {
    pushDataLayer(CONCENT_CHECKBOX_GA(partnerData.customerId, transactionDetails.submitRequest.finalRemittanceAmt, txnId, transactionDetails.purposeCode, transactionDetails.submitRequest.funds.source))

    setisCheckedConsent(!isCheckedConsent);
  };

  const handlePasswordClear = () => {
    setPassword("");
  };
  const handlePasswordChange = (e: any) => {
    setPassword(e.target.value);
  };

  const handleBankQueryTextChange = (query: string) => {
    setBankQueryText(query);
  };

  const handleSubmit = () => {
    pushDataLayer(UPLOAD_YES_GA(partnerData.customerId, transactionDetails.submitRequest.finalRemittanceAmt, txnId, transactionDetails.purposeCode, transactionDetails.submitRequest.funds.source))
    history.push(`${APP_URLS.CONFIRM.replace(":txnId", txnId)}`);
  }

  const handleConfirm = () => {
    if (!continueLater) {
      pushDataLayer(UPLOAD_NO_GA(partnerData.customerId, transactionDetails.submitRequest.finalRemittanceAmt, txnId, transactionDetails.purposeCode, transactionDetails.submitRequest.funds.source))
    } else {
      pushDataLayer(DO_LATER_GA(partnerData.customerId, transactionDetails.submitRequest.finalRemittanceAmt, txnId, transactionDetails.purposeCode, transactionDetails.submitRequest.funds.source))
    }
    setContinueLater(!continueLater);
  }

  const renderUploadedDocuments = () => {
    return (
      uploadDetailsResponse.fileList.map((item, index) => {
        return (
          <div key={index} className="doucument-item">
            <div>
              <RightTickFilled height={20} width={20} className="successful" />
            </div>
            <div className="doc-item-wrapper">
              <Text fontSize={14} className="doc-item-name">{trimFileName(item)}</Text>
            </div>
          </div>
        )
      })
    )
  }

  const onListClick = () => {
    setOpenModal(true)
  }

  return (
    <Fragment>
      {isLoading && <Loader />}
      {continueLater && <PageHeader className="page-header" />}
      <div className="container">
        {continueLater ? (
          <div className="upload-container">
            <div className="upload-wrapper">
              <div className="upload-heading-wrapper">
                <Text className="vintage-heading-text">{VINTAGE_PAGE_HEADING}</Text>
                {!uploadDocumentCompleted ? (<Text className="vintage-description">{VINTAGE_PAGE_DESCRIPTION}</Text>):<div className="placeholder-div"></div>}
              </div>
              <Text className="vintage-heading-text" fontSize={16} fontWeight={600}>{UPLOAD_BANK_STATEMENT}</Text>
              <div className="vintage-content-wrapper">
                <AsyncAutocomplete
                  disabled={isFieldsDisabled}
                  setOptionSelected={handleSelectBank}
                  options={institutionOptions}
                  queryText={bankQueryText}
                  onQueryTextChange={handleBankQueryTextChange}
                  className="bank"
                  placeholder={uploadDetailsResponse.institutionName !== "" ? uploadDetailsResponse.institutionName : "Enter your bank name"}
                />
                <div className="upload-doc">
                  <div className="upload">
                    <Text fontWeight={600}>Upload Document</Text>
                    <AxisButton disabled={disableUpload || isFieldsDisabled} component="label" className="upload-doc-heading">
                      <>
                        Upload
                        <input
                          type="file"
                          hidden
                          accept="application/pdf"
                          ref={inputRef}
                          key={documentInputKey}
                          onChange={handleOnDocumentSelected}
                        />
                      </>
                    </AxisButton>
                  </div>
                  <Text fontSize={12} className="upload-doc-subheading">Upload ePDF File only</Text>
                </div>
              </div>
              {fileSizeErrpr && <Text className={"error-text"}>Selected file size is greater than 2 MB</Text>}
              {fileTypeErrpr && <Text className={"error-text"}>Selected file type is not ePDF</Text>}
              {uploadFailure && <Text className={"error-text"}>{errorMessage}</Text>}
              <div className="document-list">
                {
                  !isFieldsDisabled && documents.map((item, index) => {
                    return <div key={index} className="doucument-item">
                      <div>
                        <RightTickFilled height={20} width={20} className="successful" />
                      </div>
                      <div className="doc-item-wrapper">
                        <Text fontSize={14} className="doc-item-name">{trimFileName(item.name)}</Text>
                      </div>
                      <div>
                        <AxisButton onClick={() => removeUploadedDocument(index)} component="label" className="remove-document">Remove</AxisButton>
                      </div>
                    </div>
                  })
                }
                {isFieldsDisabled && renderUploadedDocuments()}
              </div>
              {
                documents.length > 0 &&
                <div className="doc-password-container">
                  <Checkbox className="checkbox" onChange={handleCheckboxClick} required={true} checked={isChecked} />
                  <Text fontSize={12} className="doc-pass-helper">Your file is password protected?</Text>
                </div>
              }
              {
                isChecked &&
                <TextInput
                  customStyle={isFieldsDisabled ? "password-disabled" : "input-text"}
                  fullWidth={true}
                  value={password}
                  disabled={isFieldsDisabled}
                  label={PASSWORD_INPUT_PLACEHOLDER}
                  type="password"
                  suffix={true}
                  suffixOnClick={handlePasswordClear}
                  suffixElement={isFieldsDisabled ? null : <ClearIcon height={25} width={25} />}
                  handleOnChange={(e) => handlePasswordChange(e)}
                  onKeyPress ={blockInvalidChar}
                />
              }
              <div className="desc-wrapper">
                <ul>
                {isChecked && <li><Text className="item"><a onClick={() => onListClick()} className="list-text-link">CLICK HERE</a> for the list of special characters restricted in the password.</Text></li>}
                  <li><Text className="item">Upload file upto 2 MB only</Text></li>
                  <li><Text className="item">Provide password for protected files</Text></li>
                  <li><Text className="item">You can upload upto 4 files</Text></li>
                  <li><Text className="item">Document upload may take a minute. Do not refresh page on submit.</Text></li>
                </ul>
              </div>
              
              <Card>
            <div className="tax-wrapper">
              <div className="tax-body">
          <div className="checkbox">
                <Checkbox onChange={handleConsentCheckboxClick} required={true} checked={isCheckedConsent} />
                <div className="consent-content" dangerouslySetInnerHTML={{ __html: transactionDetails.uploadFileContent }} />
            </div>
              </div>
              <div className="tax-note">
              <InfoIcon className="note-icon"/>
              <Text fontStyle="italic">Note: In case these conditions are not met we cannot proceed with this transaction.</Text>
              </div>
            </div>
          </Card>
            </div>
            <div className="proceed-container">
              {!isFieldsDisabled && resumeJourneyEligibility && <AxisButton onClick={handleConfirm}   target="_blank" customStyle={"submit-btn-secondary "} variant="outlined">
                <Text className={"submit-btn-text"}>I Will do it later</Text>
              </AxisButton>}
              <AxisButton onClick={handleProceed} disabled={disableProceed} disableElevation customStyle={"submit-btn-primary"} variant="contained">
                <Text className={"submit-btn-text"}>Continue</Text>
              </AxisButton>
            </div>
          </div>

        )
          : (
            <div className="later-container">
              <div className="continue-card-container">
                <Card>
                  <div className="card-details">
                    <Text
                      fontWeight={700}
                      textAlign="center"
                      fontSize="20px"
                      className={"card-header"}
                    >
                      Are you sure you want to upload the bank statement later?
                  </Text>
                    <Text
                      textAlign="center"
                      fontSize="16px"
                      className={"card-body"}
                    >
                      You will be dropped from this journey upon clicking ‘Yes’ and
                      a continue journey link will be shared on your email address.
                  </Text>
                  </div>
                </Card>
              </div>
              <div className="button-handler">
                <AxisButton
                  onClick={handleConfirm}
                  customStyle={"submit-btn-secondary"}
                  variant="outlined"
                >
                  <Text
                    textAlign="center"
                    fontSize="16px"
                    className={"submit-btn-text"}
                  >
                    No
                </Text>
                </AxisButton>
                <AxisButton
                  onClick={handleSubmit}
                  customStyle={"submit-btn-primary"}
                  variant="contained"
                >
                  <Text
                    textAlign="center"
                    fontSize="16px"
                    className={"submit-btn-text"}
                  >
                    Yes
                </Text>
                </AxisButton>
              </div>
            </div>
          )
        }
        {openModal && <NotAllowedCharsModal setOpenModal={setOpenModal} openModal={openModal} />}
      </div>
    </Fragment>
  );
};

export default UploadDocument;
